import { render, staticRenderFns } from "./Tiempos.vue?vue&type=template&id=6ab4aa34&scoped=true&"
import script from "./Tiempos.vue?vue&type=script&lang=ts&"
export * from "./Tiempos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab4aa34",
  null
  
)

export default component.exports